import { Box, Typography } from '@mui/material';


export const TimeSlotChip = ({ label, variant , onClick,selected }) => {
    const iscontained =  selected;
    return (
        <Box
            onClick={onClick}
            sx={{
                background: iscontained ? "#DC143C" : 'primary.main',
                border: '1px solid #DC143C',
                padding: 0,
                mx: 1,
                borderRadius: '5px',
                minHeight: '35px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 1,
                cursor:"pointer"
            }}
        >
            <Typography
                variant="body2"
                sx={{
                    color: iscontained ? "primary.main" : '#DC143C',
                    textTransform: 'capitalize',
                }}
            >
                {label}
            </Typography>
        </Box>
    );
};
